// extracted by mini-css-extract-plugin
export default {"actions":"choose-delegate-action_actions__b7MZN","confirmationText":"choose-delegate-action_confirmationText__hGvT3"};